import IpubRadioGroup from '../radio/src/group'

/* istanbul ignore next */
IpubRadioGroup.install = function(Vue) {
  Vue.component(IpubRadioGroup.name, IpubRadioGroup)
}

export default IpubRadioGroup
